"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableHeaderColumnLabelTooltipIcon = exports.StyledTableHeaderColumnLabelArrowIcon = exports.StyledTableHeaderColumnLabel = exports.StyledTableHeaderColumn = exports.StyledTableHeaderContainer = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
exports.StyledTableHeaderContainer = Theme_1.styled.tr `
  border: 1px solid ${(props) => props.theme.colors.gray[30]};
  background-color: ${(props) => props.isStatic ? props.theme.colors.gray[20] : props.theme.white};
  height: 22px;
`;
exports.StyledTableHeaderColumn = Theme_1.styled.th `
  width: ${(props) => (props.width ? `${props.width}%` : 'auto')};
  padding: 12px 6px;
  &:first-child {
    padding-left: 16px;
    padding-right: 0px;
  }
`;
exports.StyledTableHeaderColumnLabel = Theme_1.styled.span `
  font-family: proxima-nova, sans-serif;
  font-weight: 400;
  font-size: 12px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  float: ${(props) => props.alignment};
  color: ${(props) => props.columnIndex === props.sortedColumnIndex
    ? props.theme.colors.blue[50]
    : props.isStatic
        ? props.theme.colors.gray[70]
        : props.theme.colors.gray[90]};
  background-color: ${(props) => props.columnIndex === props.sortedColumnIndex
    ? props.theme.colors.blue[10]
    : 'transparent'};
  padding: 6px 9px;
  ${(props) => props.alignment === 'right' && !props.isSortable && `padding-right: 22px;`}
  user-select: none;
  width: fit-content;
  transition: 100ms linear;
  & > #arrow_icon_container_${(props) => props.columnIndex} {
    opacity: ${(props) => props.columnIndex === props.sortedColumnIndex ? 1 : 0};
  }
  ${(props) => props.isSortable && `cursor: pointer;`}
  ${(props) => props.isSortable &&
    props.columnIndex !== props.sortedColumnIndex &&
    `&:hover {
      background-color: ${props.theme.colors.gray[20]};
      & > #arrow_icon_container_${props.columnIndex} {
        opacity: 1;
      }
  }`}
`;
exports.StyledTableHeaderColumnLabelArrowIcon = Theme_1.styled.div `
  margin-left: 4px;
  transition: 100ms linear;
  & > div {
    transition: 100ms linear;
    transform: rotate(
      ${(props) => props.sortDirection === 'asc' && props.isActive ? '180' : '0'}deg
    );
    cursor: pointer;
  }
`;
exports.StyledTableHeaderColumnLabelTooltipIcon = Theme_1.styled.div `
  margin-right: 4px;
`;
//# sourceMappingURL=TableHeader.styles.js.map